import React from "react";
import foto1 from './img/bannerlogo.png'; // Asegúrate de que la ruta sea correcta

const Banner1 = () => {
  return (
    <div className="flex w-full flex-col lg:flex-row rounded-md bg-custom-color px-4 py-8 md:px-8 md:py-10 lg:py-10 lg:px-20">
      {/* Contenedor de texto */}
      <div className="w-full text-center lg:text-left">
        <h5 className="mb-3 max-w-full text-lg font-bold text-white md:text-xl lg:text-3xl lg:leading-[35px]">
          <b>"DLS - Descargos Laborales"</b> es un software diseñado para optimizar y simplificar la gestión de descargos laborales
        </h5>
        <p className="mb-3 max-w-full text-lg font-medium text-[#E3DAFF] md:w-[20%] lg:w-[100%]">
          Ofrecemos herramientas intuitivas que ayudan a las organizaciones a tomar decisiones disciplinarias justas y bien fundamentadas.
        </p>

        <div className="mt-6 flex flex-col items-center justify-center gap-4 sm:flex-row sm:justify-start">
          <button className="w-full sm:w-auto text-black linear rounded-md bg-yellowlight px-4 py-2 text-center text-base font-medium transition duration-200 hover:!bg-yellowbold active:!bg-bg-yellowbold">
            Cómo Funciona
          </button>
          <a href="/admin/capacitaciones">
            <button className="w-full sm:w-auto text-base font-medium text-yellowlight hover:text-lightPrimary sm:ml-4">
              Soporte técnico
            </button>
          </a>
        </div>
      </div>

      {/* Contenedor de imagen */}
      <div className="w-full lg:w-1/2 flex items-center justify-center lg:justify-end mt-2 lg:mt-0">
        <img
          src={foto1}
          alt="Imagen descriptiva"
          className="w-full lg:w-1/2"
        />
      </div>
    </div>
  );
};

export default Banner1;
